module.exports = __webpack_public_path__ + "img/Reports-Assessment.8d16293b.svg";